import React from "react";

export const CultureIndexIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6V26H26"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 24.5382L13 15.5L17.5 19L23.8684 9.65381M23.8684 9.65381L19 10.5M23.8684 9.65381L25 14"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const LearningIcon = () => {
  return (
    <svg
      width="32"
      height="27"
      viewBox="0 0 32 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 4.83073C15.7311 4.63612 16.2689 4.63612 16.75 4.83074L27.4169 9.14594C29.0835 9.82015 29.0835 12.1798 27.4169 12.854L16.75 17.1692C16.2689 17.3638 15.7311 17.3638 15.25 17.1692L4.58308 12.854C2.91646 12.1798 2.91646 9.82015 4.58308 9.14593L15.25 4.83073Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.5 12L28.5 17.5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 14.5V21.8092C8 22.2568 8.14929 22.6926 8.48175 22.9922C9.42622 23.8433 11.8036 25.5 16 25.5C20.1964 25.5 22.5738 23.8433 23.5183 22.9922C23.8507 22.6926 24 22.2568 24 21.8092V14.5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PsychologicalICON = () => {
  return (
    <svg
      width="31"
      height="29"
      viewBox="0 0 31 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9117 21.8337C13.1846 21.6533 11.5018 21.1747 9.93832 20.4192C8.45636 19.6837 7.102 18.7152 5.92684 17.5506C4.45743 16.0691 3.2892 14.3168 2.48681 12.3906C1.83348 10.9506 1.35115 9.43907 1.0497 7.88685C0.943895 7.34906 1.00795 6.79167 1.233 6.2919C1.45805 5.79213 1.83295 5.37472 2.30576 5.09748C4.00313 4.09942 5.79388 3.26943 7.65252 2.6193C10.0288 1.78294 12.4993 1.24324 15.0078 1.01245C15.5578 0.958996 16.1107 1.07855 16.5895 1.35444C17.0682 1.63033 17.4489 2.04878 17.6784 2.55141C17.9193 3.04661 18.1327 3.55471 18.3177 4.07339C18.3177 4.07339 18.4422 4.46945 18.5497 4.91077C18.7699 6.01172 18.8798 7.13187 18.8779 8.25461"
        stroke="#FFFFFF"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M17.7407 20.1357C19.0206 20.5416 20.3589 20.7328 21.7013 20.7015C22.8538 20.6729 23.9965 20.4824 25.096 20.1357C24.9683 20.991 24.572 21.7835 23.9645 22.3989C23.4775 22.9022 22.8552 23.2537 22.1727 23.411C21.4903 23.5682 20.7769 23.5246 20.1188 23.2853C19.4606 23.0459 18.8859 22.6212 18.4639 22.0623C18.0419 21.5034 17.7907 20.8343 17.7407 20.1357Z"
        stroke="#FFFFFF"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M9.25391 16.1753C9.6595 15.4692 10.2452 14.8835 10.9513 14.4779C11.4738 14.1782 12.0509 13.9859 12.6487 13.9121"
        stroke="#FFFFFF"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
      <path
        d="M22.6688 27.8435C22.3585 28.0886 21.9776 28.2276 21.5824 28.2398C21.1871 28.252 20.7984 28.1369 20.4735 27.9114C17.2633 25.7101 14.8439 22.537 13.5708 18.8587C12.7035 16.2726 12.4441 13.5213 12.8127 10.8187C12.8625 10.4778 13.0056 10.1572 13.2263 9.89259C13.447 9.62796 13.7366 9.42957 14.0631 9.31937C18.7048 7.71891 23.7184 7.53964 28.4625 8.80449C28.8168 8.89978 29.1348 9.09789 29.3765 9.37381C29.6182 9.64974 29.7727 9.99109 29.8205 10.3548C30.2183 13.2207 29.9531 16.1397 29.0453 18.8869C27.842 22.4321 25.625 25.5462 22.6688 27.8435Z"
        stroke="#FFFFFF"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.06403 9.72233C5.15193 9.87459 5.26897 10.008 5.40845 10.1151C5.54793 10.2221 5.70712 10.3006 5.87694 10.3461C6.04676 10.3916 6.22388 10.4032 6.39819 10.3803C6.5725 10.3573 6.74058 10.3003 6.89283 10.2124C7.04509 10.1245 7.17854 10.0074 7.28557 9.86794C7.39259 9.72846 7.4711 9.56926 7.5166 9.39944C7.56211 9.22962 7.57371 9.0525 7.55077 8.8782C7.52782 8.70389 7.47076 8.53581 7.38286 8.38355L6.22344 9.05294L5.06403 9.72233Z"
        fill="#FFFFFF"
      />
      <path
        d="M26.6536 14.7557C26.6991 14.5859 26.7107 14.4088 26.6878 14.2344C26.6649 14.0601 26.6078 13.8921 26.5199 13.7398C26.432 13.5875 26.315 13.4541 26.1755 13.3471C26.036 13.24 25.8768 13.1615 25.707 13.116C25.5372 13.0705 25.36 13.0589 25.1857 13.0819C25.0114 13.1048 24.8433 13.1619 24.6911 13.2498C24.5388 13.3377 24.4054 13.4547 24.2984 13.5942C24.1913 13.7337 24.1128 13.8929 24.0673 14.0627L25.3605 14.4092L26.6536 14.7557Z"
        fill="#FFFFFF"
      />
      <path
        d="M12.0965 6.38129C12.142 6.55111 12.2205 6.7103 12.3275 6.84978C12.4345 6.98926 12.568 7.1063 12.7202 7.1942C12.8725 7.28211 13.0406 7.33916 13.2149 7.36211C13.3892 7.38506 13.5663 7.37345 13.7361 7.32795C13.906 7.28244 14.0652 7.20394 14.2046 7.09691C14.3441 6.98988 14.4611 6.85643 14.5491 6.70418C14.637 6.55192 14.694 6.38384 14.717 6.20953C14.7399 6.03523 14.7283 5.85811 14.6828 5.68829L13.3896 6.03479L12.0965 6.38129Z"
        fill="#FFFFFF"
      />
      <path
        d="M18.6433 14.1744C18.5978 14.0046 18.5193 13.8454 18.4122 13.7059C18.3052 13.5664 18.1718 13.4494 18.0195 13.3615C17.8672 13.2736 17.6992 13.2165 17.5249 13.1936C17.3505 13.1706 17.1734 13.1822 17.0036 13.2277C16.8338 13.2732 16.6746 13.3517 16.5351 13.4588C16.3956 13.5658 16.2786 13.6992 16.1907 13.8515C16.1028 14.0037 16.0457 14.1718 16.0228 14.3461C15.9998 14.5204 16.0114 14.6976 16.057 14.8674L17.3501 14.5209L18.6433 14.1744Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export const CommunicationsIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.939 12.7952C25.7006 10.4338 24.7673 8.19615 23.2572 6.36518C21.747 4.53422 19.7279 3.19219 17.455 2.50878C15.1822 1.82537 12.7577 1.8313 10.4882 2.5258C8.21872 3.2203 6.20614 4.57218 4.70497 6.4105C3.2038 8.24882 2.28147 10.491 2.05461 12.8535C1.82774 15.216 2.30654 17.5927 3.43045 19.6831C4.55436 21.7735 6.27291 23.4837 8.36877 24.5974C10.4646 25.7111 12.8437 26.1782 15.205 25.9398"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="19" cy="25" r="1" fill="white" />
      <circle cx="22" cy="23" r="1" fill="white" />
      <circle cx="24.3999" cy="20" r="1" fill="white" />
      <circle cx="25.7998" cy="16.5" r="1" fill="white" />
    </svg>
  );
};
export const CommunicationsWhiteIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.939 12.7952C25.7006 10.4338 24.7673 8.19615 23.2572 6.36518C21.747 4.53422 19.7279 3.19219 17.455 2.50878C15.1822 1.82537 12.7577 1.8313 10.4882 2.5258C8.21872 3.2203 6.20614 4.57218 4.70497 6.4105C3.2038 8.24882 2.28147 10.491 2.05461 12.8535C1.82774 15.216 2.30654 17.5927 3.43045 19.6831C4.55436 21.7735 6.27291 23.4837 8.36877 24.5974C10.4646 25.7111 12.8437 26.1782 15.205 25.9398"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="19" cy="25" r="1" fill="white" />
      <circle cx="22" cy="23" r="1" fill="white" />
      <circle cx="24.3999" cy="20" r="1" fill="white" />
      <circle cx="25.7998" cy="16.5" r="1" fill="white" />
    </svg>
  );
};
export const DEI = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9412 4L12.9412 6.64706"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2942 17.2354H11.6177"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2944 22.5293H11.618"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8826 17.2354H22.2061"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8826 22.5293H22.2061"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5588 4L19.5588 6.64706"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="5"
        y="5.32324"
        width="22.5"
        height="22.5"
        rx="3"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.32349 11.9414H26.1764"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ProfileIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_817_1545)">
        <circle
          cx="15.5"
          cy="9.75"
          r="5.75"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27 28.4375C27 26.7385 26.7025 25.0562 26.1246 23.4865C25.5467 21.9169 24.6996 20.4907 23.6317 19.2893C22.5639 18.0879 21.2961 17.135 19.9009 16.4848C18.5056 15.8346 17.0102 15.5 15.5 15.5C13.9898 15.5 12.4944 15.8346 11.0991 16.4848C9.7039 17.135 8.43615 18.0879 7.36827 19.2893C6.3004 20.4907 5.45331 21.9169 4.87539 23.4865C4.29746 25.0562 4 26.7385 4 28.4375L15.5 28.4375H27Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_817_1545">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ProfileWhiteIcon = () => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6681 8.83735C12.8296 7.90731 13.5688 6.51187 13.5688 4.9614C13.5688 2.2224 11.2987 0 8.50019 0C5.70202 0 3.43162 2.22203 3.43162 4.9614C3.43162 6.51187 4.17074 7.90731 5.33226 8.83735C1.47828 10.7494 0 15.6073 0 18.9665C0 19.535 0.475076 20 1.05582 20H15.9442C16.525 20 17 19.535 17 18.9665C17 15.6072 15.5217 10.6976 11.6677 8.83735H11.6681ZM8.50019 2.01586C10.1368 2.01586 11.4566 3.30785 11.4566 4.90981C11.4566 6.51178 10.1368 7.80377 8.50019 7.80377C6.86362 7.80377 5.54373 6.51178 5.54373 4.90981C5.54373 3.30785 6.86362 2.01586 8.50019 2.01586ZM2.16481 17.9331C2.58722 12.0417 6.54685 10.2847 8.18351 10.1296H8.81694C10.4535 10.2846 14.4132 12.0417 14.8356 17.9331H2.16481Z"
        fill="white"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1L15 6.5M15 6.5L9.5 12M15 6.5H1"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RightArrowIconblue = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1L15 6.5M15 6.5L9.5 12M15 6.5H1"
        stroke="#6846C7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const RightArrowIconhr = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1L15 6.5M15 6.5L9.5 12M15 6.5H1"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CertificateDownloadIcon = () => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <mask
          id="path-1-outside-1_406_9393"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="21"
          fill="black"
        >
          <rect fill="white" width="17" height="21" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.53156 8.8286C2.53603 8.71475 2.58548 8.60743 2.66905 8.53012L2.66886 8.53005C2.75243 8.45262 2.86333 8.4116 2.97705 8.41608C3.09077 8.42042 3.19823 8.46987 3.2754 8.55356L8.08541 13.7509V1.42932C8.08541 1.19217 8.27758 1 8.51473 1C8.75188 1 8.94405 1.19217 8.94405 1.42932V13.7509L13.7541 8.55356C13.9151 8.37953 14.1866 8.36905 14.3606 8.53005C14.5345 8.69105 14.545 8.96269 14.384 9.13659L9.11047 14.8353C8.95739 15.0025 8.7412 15.0975 8.51453 15.0975C8.28798 15.0975 8.07179 15.0022 7.91885 14.8351L2.64567 9.13666C2.56823 9.05323 2.52722 8.94232 2.53156 8.8286ZM1 15.0074C1.00013 14.7703 1.1923 14.5781 1.42932 14.5781C1.66647 14.5781 1.85864 14.7703 1.85864 15.0074V18.5938C1.88458 18.7571 1.97185 18.9043 2.10269 19.0052C2.23353 19.1063 2.39799 19.1534 2.56243 19.1372H14.4604C14.6248 19.1534 14.7893 19.1063 14.9201 19.0052C15.0509 18.9043 15.1382 18.7571 15.1642 18.5938V15.0074C15.1642 14.7703 15.3563 14.5781 15.5935 14.5781C15.8306 14.5781 16.0228 14.7703 16.0228 15.0074V18.5938C15.9999 18.9864 15.8229 19.354 15.5302 19.6166C15.2376 19.8792 14.853 20.0155 14.4604 19.9958H2.56243C2.16978 20.0155 1.78518 19.8792 1.49258 19.6166C1.19984 19.3539 1.02287 18.9864 1 18.5938V15.0074Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.53156 8.8286C2.53603 8.71475 2.58548 8.60743 2.66905 8.53012L2.66886 8.53005C2.75243 8.45262 2.86333 8.4116 2.97705 8.41608C3.09077 8.42042 3.19823 8.46987 3.2754 8.55356L8.08541 13.7509V1.42932C8.08541 1.19217 8.27758 1 8.51473 1C8.75188 1 8.94405 1.19217 8.94405 1.42932V13.7509L13.7541 8.55356C13.9151 8.37953 14.1866 8.36905 14.3606 8.53005C14.5345 8.69105 14.545 8.96269 14.384 9.13659L9.11047 14.8353C8.95739 15.0025 8.7412 15.0975 8.51453 15.0975C8.28798 15.0975 8.07179 15.0022 7.91885 14.8351L2.64567 9.13666C2.56823 9.05323 2.52722 8.94232 2.53156 8.8286ZM1 15.0074C1.00013 14.7703 1.1923 14.5781 1.42932 14.5781C1.66647 14.5781 1.85864 14.7703 1.85864 15.0074V18.5938C1.88458 18.7571 1.97185 18.9043 2.10269 19.0052C2.23353 19.1063 2.39799 19.1534 2.56243 19.1372H14.4604C14.6248 19.1534 14.7893 19.1063 14.9201 19.0052C15.0509 18.9043 15.1382 18.7571 15.1642 18.5938V15.0074C15.1642 14.7703 15.3563 14.5781 15.5935 14.5781C15.8306 14.5781 16.0228 14.7703 16.0228 15.0074V18.5938C15.9999 18.9864 15.8229 19.354 15.5302 19.6166C15.2376 19.8792 14.853 20.0155 14.4604 19.9958H2.56243C2.16978 20.0155 1.78518 19.8792 1.49258 19.6166C1.19984 19.3539 1.02287 18.9864 1 18.5938V15.0074Z"
          fill="#6846C7"
        />
        <path
          d="M2.66905 8.53012L3.00858 8.89716L3.59806 8.35184L2.8486 8.06347L2.66905 8.53012ZM2.53156 8.8286L2.03195 8.80898L2.03193 8.80951L2.53156 8.8286ZM2.66886 8.53005L2.32902 8.16329L1.74053 8.7086L2.48931 8.9967L2.66886 8.53005ZM2.97705 8.41608L2.95741 8.91569L2.95797 8.91571L2.97705 8.41608ZM3.2754 8.55356L2.90783 8.89252L2.90844 8.89318L3.2754 8.55356ZM8.08541 13.7509L7.71845 14.0905L8.58541 15.0272V13.7509H8.08541ZM8.94405 13.7509H8.44405V15.0272L9.31101 14.0905L8.94405 13.7509ZM13.7541 8.55356L14.121 8.89318L14.1211 8.89311L13.7541 8.55356ZM14.3606 8.53005L14.7003 8.16315L14.7001 8.16302L14.3606 8.53005ZM14.384 9.13659L14.0171 8.79691L14.017 8.797L14.384 9.13659ZM9.11047 14.8353L8.74349 14.4957L8.74176 14.4976L9.11047 14.8353ZM7.91885 14.8351L8.28771 14.4975L8.28583 14.4955L7.91885 14.8351ZM2.64567 9.13666L3.01265 8.79707L3.01216 8.79655L2.64567 9.13666ZM1 15.0074L0.5 15.0072V15.0074H1ZM1.85864 18.5938H1.35864V18.6332L1.36483 18.6722L1.85864 18.5938ZM2.10269 19.0052L2.40835 18.6095L2.40811 18.6093L2.10269 19.0052ZM2.56243 19.1372V18.6372H2.53782L2.51333 18.6396L2.56243 19.1372ZM14.4604 19.1372L14.5095 18.6396L14.485 18.6372H14.4604V19.1372ZM14.9201 19.0052L14.6147 18.6093L14.6145 18.6095L14.9201 19.0052ZM15.1642 18.5938L15.658 18.6722L15.6642 18.6332V18.5938H15.1642ZM16.0228 18.5938L16.5219 18.6229L16.5228 18.6083V18.5938H16.0228ZM15.5302 19.6166L15.1964 19.2444L15.1963 19.2445L15.5302 19.6166ZM14.4604 19.9958L14.4854 19.4965L14.4729 19.4958H14.4604V19.9958ZM2.56243 19.9958V19.4958H2.54992L2.53742 19.4965L2.56243 19.9958ZM1.49258 19.6166L1.15862 19.9887L1.15864 19.9887L1.49258 19.6166ZM1 18.5938H0.5V18.6083L0.500846 18.6228L1 18.5938ZM2.32951 8.16309C2.14859 8.33045 2.04162 8.56277 2.03195 8.80898L3.03118 8.84822C3.03045 8.86674 3.02238 8.8844 3.00858 8.89716L2.32951 8.16309ZM2.48931 8.9967L2.4895 8.99677L2.8486 8.06347L2.84841 8.0634L2.48931 8.9967ZM2.9967 7.91646C2.75011 7.90676 2.5099 7.99569 2.32902 8.16329L3.0087 8.89681C2.99495 8.90955 2.97656 8.91644 2.95741 8.91569L2.9967 7.91646ZM3.64298 8.21461C3.47546 8.03294 3.24251 7.92585 2.99614 7.91644L2.95797 8.91571C2.93904 8.91499 2.921 8.90679 2.90783 8.89251L3.64298 8.21461ZM8.45237 13.4112L3.64236 8.21394L2.90844 8.89318L7.71845 14.0905L8.45237 13.4112ZM7.58541 1.42932V13.7509H8.58541V1.42932H7.58541ZM8.51473 0.5C8.00144 0.5 7.58541 0.916029 7.58541 1.42932H8.58541C8.58541 1.46831 8.55372 1.5 8.51473 1.5V0.5ZM9.44405 1.42932C9.44405 0.916029 9.02802 0.5 8.51473 0.5V1.5C8.47574 1.5 8.44405 1.46831 8.44405 1.42932H9.44405ZM9.44405 13.7509V1.42932H8.44405V13.7509H9.44405ZM13.3871 8.21394L8.57709 13.4112L9.31101 14.0905L14.121 8.89318L13.3871 8.21394ZM14.7001 8.16302C14.3235 7.81462 13.7357 7.83715 13.387 8.21401L14.1211 8.89311C14.0944 8.92191 14.0496 8.92349 14.0211 8.89708L14.7001 8.16302ZM14.7509 9.47627C15.0995 9.09972 15.0768 8.51173 14.7003 8.16315L14.0209 8.89695C13.9922 8.87037 13.9905 8.82566 14.0171 8.79691L14.7509 9.47627ZM9.47745 15.1749L14.751 9.47619L14.017 8.797L8.74349 14.4957L9.47745 15.1749ZM8.51453 15.5975C8.88127 15.5975 9.23129 15.4437 9.47918 15.173L8.74176 14.4976C8.68349 14.5612 8.60112 14.5975 8.51453 14.5975V15.5975ZM7.54999 15.1726C7.79754 15.4431 8.14752 15.5975 8.51453 15.5975V14.5975C8.42844 14.5975 8.34604 14.5613 8.2877 14.4975L7.54999 15.1726ZM2.27868 9.47626L7.55187 15.1747L8.28583 14.4955L3.01265 8.79707L2.27868 9.47626ZM2.03193 8.80951C2.02253 9.05563 2.11125 9.29584 2.27917 9.47678L3.01216 8.79655C3.02522 8.81061 3.03191 8.82901 3.0312 8.84769L2.03193 8.80951ZM1.42932 14.0781C0.916003 14.0781 0.500283 14.4942 0.5 15.0072L1.5 15.0077C1.49998 15.0463 1.4686 15.0781 1.42932 15.0781V14.0781ZM2.35864 15.0074C2.35864 14.4941 1.9426 14.0781 1.42932 14.0781V15.0781C1.39033 15.0781 1.35864 15.0464 1.35864 15.0074H2.35864ZM2.35864 18.5938V15.0074H1.35864V18.5938H2.35864ZM2.40811 18.6093C2.37841 18.5864 2.35841 18.5529 2.35245 18.5153L1.36483 18.6722C1.41075 18.9613 1.56529 19.2221 1.79728 19.4011L2.40811 18.6093ZM2.51333 18.6396C2.47566 18.6433 2.43814 18.6325 2.40835 18.6095L1.79703 19.4009C2.02892 19.58 2.32031 19.6635 2.61153 19.6348L2.51333 18.6396ZM14.4604 18.6372H2.56243V19.6372H14.4604V18.6372ZM14.6145 18.6095C14.5847 18.6325 14.5471 18.6433 14.5095 18.6396L14.4113 19.6348C14.7025 19.6635 14.9939 19.58 15.2258 19.4009L14.6145 18.6095ZM14.6703 18.5153C14.6644 18.5529 14.6444 18.5864 14.6147 18.6093L15.2255 19.4011C15.4575 19.2221 15.6121 18.9613 15.658 18.6722L14.6703 18.5153ZM14.6642 15.0074V18.5938H15.6642V15.0074H14.6642ZM15.5935 14.0781C15.0802 14.0781 14.6642 14.4942 14.6642 15.0074H15.6642C15.6642 15.0464 15.6325 15.0781 15.5935 15.0781V14.0781ZM16.5228 15.0074C16.5228 14.4942 16.1068 14.0781 15.5935 14.0781V15.0781C15.5545 15.0781 15.5228 15.0464 15.5228 15.0074H16.5228ZM16.5228 18.5938V15.0074H15.5228V18.5938H16.5228ZM15.8641 19.9888C16.2551 19.6381 16.4914 19.1471 16.5219 18.6229L15.5236 18.5647C15.5084 18.8258 15.3908 19.07 15.1964 19.2444L15.8641 19.9888ZM14.4353 20.4952C14.9598 20.5215 15.4734 20.3394 15.8642 19.9887L15.1963 19.2445C15.0019 19.419 14.7463 19.5096 14.4854 19.4965L14.4353 20.4952ZM2.56243 20.4958H14.4604V19.4958H2.56243V20.4958ZM1.15864 19.9887C1.54942 20.3394 2.06304 20.5215 2.58743 20.4952L2.53742 19.4965C2.27651 19.5095 2.02094 19.4189 1.82652 19.2445L1.15864 19.9887ZM0.500846 18.6228C0.531387 19.1472 0.76774 19.6379 1.15862 19.9887L1.82654 19.2445C1.63194 19.0698 1.51436 18.8257 1.49915 18.5647L0.500846 18.6228ZM0.5 15.0074V18.5938H1.5V15.0074H0.5Z"
          fill="#6846C7"
          mask="url(#path-1-outside-1_406_9393)"
        />
      </g>
    </svg>
  );
};
export const InfoIcon = () => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 11V16.5"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="12" cy="7.5" r="1" fill="#666666" />
    </svg>
  );
};
